import { Plus, ReceiptText, Scale } from 'lucide-react';
import { Card } from '../ui/card';
import { formatSignedCents } from '../../utils/euFormatters';

export default function EuGapBreakdown({ data }) {
  if (!data || data.total_gap === null || data.total_gap === undefined) return null;
  const cheaper = Number(data.total_gap) < 0;
  return (
    <Card className="overflow-hidden rounded-[36px_36px_12px_36px] bg-md-secondary text-md-on-secondary shadow-md1">
      <div className="p-6 sm:p-8">
        <p className="text-xs font-bold uppercase tracking-[0.14em] opacity-75">Perché costa {cheaper ? 'meno' : 'di più'}?</p>
        <div className="mt-3 flex flex-wrap items-end justify-between gap-4">
          <div>
            <h2 className="max-w-xl text-2xl font-medium leading-tight sm:text-3xl">{cheaper ? 'In Italia costa meno della media UE' : 'Il divario Italia–UE, senza scorciatoie'}</h2>
            <p className="mt-2 max-w-2xl text-sm leading-6 opacity-80">La differenza osservata è scomposta tra prezzo prima della fiscalità e tasse complessive. Non attribuisce causalità.</p>
          </div>
          <div className="numbers text-4xl font-bold tracking-[-0.04em] sm:text-5xl">{formatSignedCents(data.total_gap)}</div>
        </div>
      </div>
      <div className="grid gap-2 bg-md-surface p-3 text-md-on-surface sm:grid-cols-[1fr_auto_1fr] sm:items-stretch">
        <div className="rounded-[24px] bg-md-secondary-container p-5 text-md-on-secondary-container">
          <div className="flex items-center gap-2 text-sm font-medium"><Scale className="h-4 w-4" aria-hidden="true" />Componente pre-tasse</div>
          <div className="numbers mt-3 text-3xl font-bold tracking-tight">{formatSignedCents(data.pre_tax_gap)}</div>
        </div>
        <div className="hidden place-items-center px-1 text-md-on-surface-variant sm:grid"><Plus className="h-5 w-5" aria-label="più" /></div>
        <div className="rounded-[24px] bg-md-tertiary-container p-5 text-md-on-tertiary-container">
          <div className="flex items-center gap-2 text-sm font-medium"><ReceiptText className="h-4 w-4" aria-hidden="true" />Fiscalità</div>
          <div className="numbers mt-3 text-3xl font-bold tracking-tight">{formatSignedCents(data.tax_gap)}</div>
        </div>
      </div>
      {data.tax_contribution_share !== null && data.tax_contribution_share !== undefined && (
        <p className="bg-md-surface px-6 pb-6 text-sm leading-6 text-md-on-surface-variant">Il {new Intl.NumberFormat('it-IT', { maximumFractionDigits: 1 }).format(data.tax_contribution_share)}% del divario osservato in questa settimana coincide con la differenza nella fiscalità complessiva.</p>
      )}
    </Card>
  );
}
